// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J58h","content":"styles_content__1ACWz"};